import { OAuthStorage } from 'angular-oauth2-oidc';

/**
 * SB-15270 hybrid OAuthStorage.
 *
 * Tokens (`access_token`, `id_token`, `refresh_token`, `expires_at`, etc.) stay
 * in localStorage so a logged-in user is recognised across tabs/windows of
 * the same origin (the original reason the team overrode OAuthStorage to
 * localStorage in the first place).
 *
 * Per-flow keys (`nonce`, `PKCE_verifier`) live in sessionStorage so two
 * windows running concurrent OIDC flows can't clobber each other's
 * single-use values, which previously produced `invalid_nonce_in_state`
 * errors in the SSO-from-Firefly login path.
 */
export class OAuthHybridStorage implements OAuthStorage {
  private static readonly PER_FLOW_KEYS = new Set(['nonce', 'PKCE_verifier']);

  getItem(key: string): string | null {
    return this.backing(key).getItem(key);
  }

  setItem(key: string, data: string): void {
    this.backing(key).setItem(key, data);
  }

  removeItem(key: string): void {
    this.backing(key).removeItem(key);
  }

  private backing(key: string): Storage {
    return OAuthHybridStorage.PER_FLOW_KEYS.has(key) ? sessionStorage : localStorage;
  }
}
